import { useCurrentSessionUser } from '@ms/yammer-hooks/dist/session';

import { UseUIFeatureCheck } from '../types';

export {
  useCanCurrentUserAccessAdminSettings as useIsAdminCenterEnabled,
  useShowAnalyticsSettings as useIsInsightsAdminEnabled,
  useShowStorylineAdminSettings as useIsStorylineAdminEnabled,
} from '@ms/yammer-hooks/dist/adminSettings';
export { useCanEditNetworkQuestionSettings as useIsQuestionsAdminEnabled } from '@ms/yammer-hooks/dist/featureAccessSettings';
export { useViewerCanEditUserAchievementsSettings as useIsAchievementsAdminEnabled } from '@ms/yammer-hooks/dist/adminUserAchievementsSettings';
export { useShowLeaderSettings as useIsLeadersAdminEnabled } from '@ms/yammer-hooks/dist/leaderSettings';
export { useCanUserAdminLeadershipCorner as useIsLeadershipCornerAdminEnabled } from '@ms/yammer-hooks/dist/leadershipCorner';

export const useIsNetworkAdminEnabled: UseUIFeatureCheck = () => useCurrentSessionUser().isNetworkAdmin;

export const useIsUserRolesAdminEnabled: UseUIFeatureCheck = () => useCurrentSessionUser().canAssignUserAdminRoles;
